import React from "react";
import classNames from "../classNames";

const noop = () => {};
const defaultProps = {
  type: "password",
  onChange: noop,
};

function InputPassword({
  className,
  onChange,
  indicatorClass = "border-1 border-dark-subtle bg-light-subtle",
  ...props
}) {
  function onInput(e) {
    const value = e.target.value;
    onChange(value);
  }

  function showPasswordClick(e) {
    const input = e.target.previousElementSibling;
    const isText = input.type === "text";
    input.type = isText ? "password" : "text";
    if (isText) {
      e.target.classList.add("bi-eye-slash");
      e.target.classList.remove("bi-eye");
    } else {
      e.target.classList.remove("bi-eye-slash");
      e.target.classList.add("bi-eye");
    }
  }

  return (
    <div className="input-group">
      <input
        autoComplete="new-password"
        className={classNames("form-control border-end-0 pe-0", indicatorClass)}
        onInput={onInput}
        {...props}
      />
      <button
        type="button"
        className={classNames(
          "btn btn-link shadow-none bi bi-eye-slash bg-light-subtle",
          indicatorClass,
        )}
        onClick={showPasswordClick}
      ></button>
    </div>
  );
}

InputPassword.defaultProps = defaultProps;

export default InputPassword;
